import type VueRouter from 'vue-router/types';

export const VueRouterService = Symbol('VueRouterService');

export interface VueRouterService {
    currentRoute: VueRouter['currentRoute'];
    push: VueRouter['push'];
}
